import styled from 'styled-components';

export const DashboardContainer = styled.div`
width:100%;
min-height:100vh;
background:#1D1E22;
`;

export const Container = styled.div`
    max-width:1000px;
    display:flex;
    flex-direction:column;
    align-items:center;
    margin:auto;
    padding-top:70px;
`;

export const InlineContainer = styled.div`
    display:flex;
    flex-direction:row;

    @media screen and (max-width: 750px){
        flex-direction:column;
    }
`;
export const Box = styled.div`
    width:200px;
    height:200px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:white;
    flex-direction:column;
    border-radius:10px;
    margin:20px;
    box-shadow:0px 0px 10px black;
    text-decoration:none;
`;

export const DashboardText = styled.p`
    font-size:20px;
    font-family:'Open Sans';
    font-weight:700;
`;

export const DashboardNum = styled.p`
    font-size:30px;
    font-family:'Open Sans';
    font-weight:600;
`;

export const DashboardIcon = styled.span`
    font-size:60px;
    text-decoration:none;
    color:black;
`;

export const Table = styled.table`
    width:100%;
    border-collapse:collapse;
    text-align:center;
    color:black;
    text-transform:uppercase;
    font-family:'Open Sans';
    background:white;
    margin-bottom:20px;
`;

export const Thead = styled.thead`
width:100%;
background:#343A40;
color:white;
`;

export const Tbody = styled.tbody`
width:100%;
`;

export const Tr = styled.tr`
height:50px;
`;

export const Td = styled.td`
`;

export const Th = styled.th`
height:50px;
`;

export const Tdl = styled.td`
background:#D9E5E7;
`;


export const TableContainer = styled.div`
width:70%;
`;